import { EffectData, Effect, createEffect } from '@beatflyer/shaders-lib';
import BlendMode from 'data/BlendMode';
import { SignalSource } from 'data/SignalSource';
import { removeLayer, SPLIT_LAYER } from 'state/actions';
import {
  getEffectById,
  getLayerById,
  getLayerCopyIndex
} from 'state/FlyerState';
import RootState from 'state/RootState';
import { filterCache } from 'state/Store';
import { getCloneId, newUUID } from 'utils';
import { Command, CommandFunction } from './Command';

export class SplitLayerCommand extends Command {
  layerId: string;
  bottomEffectData: EffectData | undefined;
  topEffectData: EffectData;
  blendMode: BlendMode;
  topEffectId: string;
  bottomEffectId: string | undefined;
  copyIndex: number;
  constructor(
    layerId: string,
    bottomEffectData: EffectData | undefined,
    topEffectData: EffectData,
    blendMode: BlendMode
  ) {
    super();
    this.layerId = layerId;
    this.bottomEffectData = bottomEffectData;
    this.topEffectData = topEffectData;
    this.blendMode = blendMode;
    if (bottomEffectData) {
      this.bottomEffectId = newUUID();
    }
    this.topEffectId = newUUID();
  }
  execute(firstTime?: boolean | undefined): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      if (layer) {
        if (firstTime) {
          this.copyIndex = getLayerCopyIndex(this.layerId, flyer);
        }
        if (this.bottomEffectData && this.bottomEffectId) {
          const bottomEffect = createEffect(this.bottomEffectData);
          bottomEffect.id = this.bottomEffectId;
          bottomEffect.layerTransform = layer.sprite.filterTransform;
          bottomEffect.cache = filterCache;
          bottomEffect.repeat = layer.repeat;
          bottomEffect.pixelRatio = flyer.previewPixelRatio.value;
          bottomEffect.signalSource = SignalSource.Default;
          layer.addEffect(bottomEffect, 0);
        }
        const splittedLayer = await layer.clone(this.copyIndex);
        splittedLayer.blendMode = this.blendMode;
        const topEffect = createEffect(this.topEffectData);
        topEffect.id = this.topEffectId;
        topEffect.layerTransform = layer.sprite.filterTransform;
        topEffect.cache = filterCache;
        topEffect.repeat = splittedLayer.repeat;
        topEffect.pixelRatio = flyer.previewPixelRatio.value;
        topEffect.signalSource = SignalSource.Default;
        splittedLayer.addEffect(topEffect);
        const { layers } = flyer;
        const newLayerIndex = layers.indexOf(layer) + 1;
        layers.splice(newLayerIndex, 0, splittedLayer);
        dispatch({
          type: SPLIT_LAYER
        });
      }
    };
  }
  undo(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      if (this.bottomEffectId) {
        const layer = getLayerById(flyer, this.layerId);
        const bottomEffect = getEffectById(flyer, this.bottomEffectId);
        if (layer && bottomEffect) {
          layer.removeEffect(bottomEffect as Effect);
        }
      }
      const topLayer = getLayerById(
        flyer,
        getCloneId(this.layerId, this.copyIndex)
      );
      if (topLayer) {
        dispatch(removeLayer(topLayer));
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/SplitLayerCommand.ts